import React, { useState, useRef, useEffect } from 'react';

interface ToggleFooterColumnProps {
    title: string;
    children: React.ReactNode;
}

const ToggleFooterColumn: React.FC<ToggleFooterColumnProps> = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 991);
    const contentRef = useRef<HTMLUListElement>(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 991);
            if (window.innerWidth >= 991) {
                setIsOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (contentRef.current) {
            const content = contentRef.current;
            if (isMobile) {
                if (isOpen) {
                    const contentHeight = content.scrollHeight;
                    content.style.height = `${contentHeight}px`;
                } else {
                    content.style.height = '0px';
                }
            } else {
                content.style.height = 'auto';
            }
        }
    }, [isOpen, isMobile]);

    const handleToggle = () => {
        if (isMobile) {
            setIsOpen(!isOpen);
        }
    };

    return (
        <div className="column">
            <h6 onClick={handleToggle} className={`${isOpen ? 'active' : ''}`}>
                {title}
            </h6>
            <ul ref={contentRef} className={`${isOpen ? 'active' : ''}`}>
                {children}
            </ul>
        </div>
    );
};

export default ToggleFooterColumn;
